import React from 'react'
import HeroSection from './HeroSection'
import ClientStories from './ClientStories'
import OurPromise from './OurPromise'
import ServicesOverview from './ServicesOverview'
import FinalCTA from './FinalCTA'

import AnimatedSteps from './AnimatedSteps'
import { isMobile } from 'react-device-detect'

const HomePage = () => {
	return (
		<>
			<HeroSection />
			<AnimatedSteps />
			<ClientStories />
			{!isMobile && <OurPromise />}
			<ServicesOverview />
			<FinalCTA />
		</>
	)
}

export default HomePage
